import React, { FunctionComponent, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { StatefulToolTip } from 'react-portal-tooltip';

export interface TooltipProps {
  children: string | React.ReactElement;
  parent: string | React.ReactElement;
  position?: 'top' | 'right' | 'bottom' | 'left';
  arrow?: 'top' | 'right' | 'bottom' | 'left' | 'center';
  variant?: string;
}

const Tooltip: FunctionComponent<TooltipProps> = ({
  parent, children, position = 'top', arrow = 'center', variant,
}: TooltipProps) => {
  const themeContext: any = useContext(ThemeContext);

  const tooltipStyle = {
    style: {
      background: themeContext.colors.lavenderGrey,
      padding: '12px 14px',
      fontSize: '12px',
      color: variant ? themeContext.text[variant]?.color : '#000000',
      lineHeight: '16px',
      transition: 'opacity .3s ease-in-out, visibility .3s ease-in-out',
      boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.25), 0px 1px 2px rgba(0, 0, 0, 0.18), 0px 2px 3px rgba(0, 0, 0, 0.12)',
    },
    arrowStyle: {
      color: themeContext.colors.lavenderGrey,
      borderColor: 'none',
      transition: 'opacity .3s ease-in-out, visibility .3s ease-in-out',
    },
  };

  return (
    <StatefulToolTip
      position={position}
      arrow={arrow}
      parent={parent}
      style={tooltipStyle}
    >
      {children}
    </StatefulToolTip>
  );
};

export default Tooltip;
